import React from "react";

// Peptigen Labs molecular monogram - cyan-to-lime gradient nodes forming a "P"
export function PeptigenLogo({ size = 36, showWordmark = true }) {
  const gradId = `pgGrad-${size}`;
  return (
    <div className="flex items-center gap-3" data-testid="peptigen-logo">
      <svg
        width={size}
        height={Math.round(size * 1.05)}
        viewBox="0 0 56 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Peptigen Labs"
      >
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00C2D6" />
            <stop offset="55%" stopColor="#5EEAD4" />
            <stop offset="100%" stopColor="#A6FF00" />
          </linearGradient>
        </defs>
        {/* Spine of the P */}
        <line x1="14" y1="6" x2="14" y2="56" stroke={`url(#${gradId})`} strokeWidth="2.2" strokeLinecap="round" />
        {/* Bowl bonds */}
        <path d="M14 6 Q40 6 44 18 Q48 30 30 30 L14 30" stroke={`url(#${gradId})`} strokeWidth="2.2" fill="none" strokeLinecap="round" />
        {/* Nodes */}
        <circle cx="14" cy="6" r="3.4" fill="#00C2D6" />
        <circle cx="28" cy="6" r="3.4" fill="#00C2D6" />
        <circle cx="40" cy="10" r="3.4" fill="#3BD7DE" />
        <circle cx="46" cy="20" r="3.6" fill="#5EEAD4" />
        <circle cx="38" cy="28" r="3.4" fill="#5EEAD4" />
        <circle cx="24" cy="30" r="3.4" fill="#7BEBB8" />
        <circle cx="14" cy="30" r="3.4" fill="#9BF089" />
        <circle cx="14" cy="44" r="3.4" fill="#A6FF00" />
        <circle cx="14" cy="56" r="3.6" fill="#A6FF00" />
        {/* Internal precision lines */}
        <line x1="20" y1="14" x2="34" y2="14" stroke="#00C2D6" strokeWidth="1.2" opacity="0.7" />
        <line x1="20" y1="20" x2="38" y2="20" stroke="#00C2D6" strokeWidth="1.2" opacity="0.7" />
      </svg>
      {showWordmark && (
        <div className="leading-none">
          <div
            style={{
              fontFamily: "'Exo 2', sans-serif",
              fontWeight: 800,
              fontSize: "1.1rem",
              letterSpacing: "0.16em",
              color: "#F7FAFC",
            }}
          >
            PEPTIGEN
          </div>
          <div
            style={{
              fontFamily: "'Exo 2', sans-serif",
              fontSize: "0.62rem",
              letterSpacing: "0.46em",
              color: "#5EEAD4",
              marginTop: "3px",
            }}
          >
            LABS
          </div>
        </div>
      )}
    </div>
  );
}
